module.exports = __webpack_public_path__ + "img/capone.a56017b4.png";